module.exports = __webpack_public_path__ + "img/close.1667fbd9.svg";